/* eslint-disable spaced-comment */
export interface ImportDocumentFormData {
  client_id: number
  dealer_id: number
  motorbike_id: number
  motorbike_name?: string
  client_name?: string
  import_date: string
  with_plates: boolean
}

export const validateImportDocumentForm = (values: ImportDocumentFormData): Partial<ImportDocumentFormData> => {
  const errors: Partial<ImportDocumentFormData> = {}

  const requiredFields = ['client_id', 'motorbike_id', 'import_date'] as const

  requiredFields.forEach((field) => {
    const value = values[field]
    if (field === 'client_id' || field === 'motorbike_id') {
      if (typeof value !== 'number' || value === 0) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment, @typescript-eslint/prefer-ts-expect-error
        //@ts-ignore
        errors[field] = `${field.replace('_', ' ')} is required`
      }
    } else if (typeof value !== 'string' || value.trim() === '') {
      errors[field] = `${field.replace('_', ' ')} is required`
    }
  })

  return errors
}
